
export default {
  name: 'LocationsAllContainer'
}
